<template>
    <el-popover placement="right-start" title="" trigger="hover" @show="previewTriggered = true">
        <div v-if="previewTriggered" :style="[computedPreviewStyle]">
            <el-image
                :src="buildOssImgUrl(src, 250)"
                :lazy="lazy"
                style="width: 100%; height: 100%"
            >
                <el-image
                    slot="error"
                    :src="no_pic"
                    style="width: 100%; height: 100%"
                ></el-image>
            </el-image>
        </div>
        <span class="img-box" slot="reference">
            <el-image
                :src="buildOssImgUrl(src)"
                style="margin-top: 5px"
                :style="[computedStyle, customStyle]"
            >
                <el-image
                    slot="error"
                    :src="no_pic"
                    style="margin-top: 5px"
                    :style="[computedStyle, customStyle]"
                ></el-image>
            </el-image>
            <span v-if="isDistribution == 1" class="distributor-label">分销</span>
        </span>
    </el-popover>
</template>

<script>
/**
 * 用于列表中的图片字段，提供懒加载效果及放大图效果
 */
import CONST from './const'
import no_pic from "@/assets/images/no_pic.png";
import { buildOssImgUrl } from '@/utils/oss-img';

export default {
    name: "listLazyImg",
    props: {
        src: {
            type: String,
            default: ""
        },
        isDistribution: {
            type: Number | String,
            default: 0
        },
        previewSize: {
            type: Object,
            default() {
                return {
                    width: CONST.DEFAULT_PREVIEW_SIZE_WIDTH,
                    height: CONST.DEFAULT_PREVIEW_SIZE_HEIGHT
                }
            }
        },
        size: {
            type: Object,
            default() {
                return {
                    width: CONST.DEFAULT_IMG_SIZE_WIDTH,
                    height: CONST.DEFAULT_IMG_SIZE_HEIGHT
                }
            }
        },
        customStyle: {
            type: Object,
            default(){
                return {}
            }
        },
        lazy:{
            type:Boolean,
            default:true
        }
    },
    data() {
        return {
            no_pic,
            previewTriggered: false, // 是否触发过预览 ｜ 触发过预览才展示预览中的图，否则外面虽然设置懒加载但是图片还是会加载，等于没效果
        }
    },
    methods: {
        buildOssImgUrl(url, size) {
            return buildOssImgUrl(url, size || 100);
        },
    },
    computed: {
        computedPreviewStyle() {
            let {width, height} = this.previewSize
            if (typeof width === 'string') width.replace('px', '')
            if (typeof height === 'string') height.replace('px', '')

            width = Number(width);
            height = Number(height);

            (!width || isNaN(width)) && (width = CONST.DEFAULT_PREVIEW_SIZE_WIDTH)
            (!height || isNaN(height)) && (height = CONST.DEFAULT_PREVIEW_SIZE_WIDTH)

            return {
                width: `${width}px`,
                // height: `${height}px`
            }
        },
        computedStyle() {
            let {width, height} = this.size
            if (typeof width === 'string') width.replace('px', '')
            if (typeof height === 'string') height.replace('px', '')

            width = Number(width);
            height = Number(height);

            (!width || isNaN(width)) && (width = CONST.DEFAULT_IMG_SIZE_WIDTH)
            (!height || isNaN(height)) && (height = CONST.DEFAULT_IMG_SIZE_HEIGHT)

            return {
                width: `${width}px`,
                height: `${height}px`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .img-box {
        position: relative;
        .distributor-label {
            display: inline-block;
            padding: 0px 3px;
            color: #fff;
            background: #396cf3;
            position: absolute;
            right: -14px;
            // top: -60px;
            border-radius: 3px;
            line-height: 18px;
        }
    }
</style>